// data/testimonials.js
export const testimonialsData = [
  {
    name: "Rahul Kumar",
    course: "IT - Advanced Diploma in Computer Science",
    quote: "This institute changed my career trajectory",
    photo: "👨‍💻",
    stars: 5,
    year: "2025",
   
  },
  {
    name: "Sunita Patel",
    course: "Agriculture - Diploma in Agriculture",
    quote: "Learnt modern organic techniques and now I run my own successful agri-startup.",
    photo: "👩‍🌾",
    stars: 5,
    year: "2024",
    placement: "Agri-Startup Founder"
  },
  {
    name: "Amit Bhatt",
    course: "Para-medical - Operation Theatre Technician ",
    quote: "Excellent lab training and placement support. Cleared my MLT exam with top rank.",
    photo: "🧑‍🔬",
    stars: 5,
    year: "2025",
  
  },
  {
    name: "Priya Singh",
    course: "IT -Computer Teacher Training (CTT)",
    quote: "The curriculum is industry-relevant and the projects helped me build a strong portfolio .",
    photo: "👩‍💻",
    stars: 5,
    year: "2024",
   
  }
];